module.exports = __webpack_public_path__ + "img/blinifashion.f54e6b7c.png";